import React from 'react';
import Raw from '../../common/Raw';
import PriceWithDisclaimer from '../../steps/config/priceWithDisclaimer/PriceWithDisclaimer';
import { Translate } from 'core/translate';
import orderBy from 'lodash/orderBy';

const PowertrainOptions = ({ trimInfo, disclaimer }) => {
  if (!trimInfo || !trimInfo.options || trimInfo.options.length === 0) {
    return null;
  }

  const sortedPowertrains = orderBy(
    trimInfo.options,
    [
      (elem) => {
        return (
          elem.engineType === 'STANDARD' && elem.transmissionType === 'STANDARD'
        );
      },
      'engineType',
      'msrp',
    ],
    ['desc', 'desc', 'asc']
  );

  return (
    <>
      <div className="powertrain__header-container">
        <h2 className="powertrain__header">
          <Translate value="available.powertrains.v3"></Translate>
        </h2>
      </div>
      <div className="powertrain__list">
        {sortedPowertrains.map((powerTrain) => {
          const {
            ss,
            engineDescription,
            engineDisclaimer,
            engineLabel,
            engineLongCFD,
            transmissionDescription,
            transmissionLabel,
            transmissionLongCFD,
            msrp,
            message,
            engineLargeImageUrl,
          } = powerTrain;

          return (
            <div className="powertrain__item" key={ss}>
              <div className="powertrain__info">
                <h3 className="powertrain__sub-header">
                  <Raw value={engineDescription} />{' '}
                  <span className={'powertrain__engine-label'}>
                    ({engineLabel})
                  </span>
                </h3>
                <Raw value={engineLongCFD} className="powertrain__desc-list" />
                {engineDisclaimer && (
                  <div
                    className="powertrain__disclaimer"
                    dangerouslySetInnerHTML={{ __html: engineDisclaimer }}
                  />
                )}
                <h3 className="powertrain__sub-header">
                  <Raw value={transmissionDescription} />{' '}
                  <span className={'powertrain__transmission-label'}>
                    ({transmissionLabel})
                  </span>
                </h3>
                <Raw
                  value={transmissionLongCFD}
                  className="powertrain__desc-list"
                />
                <div className="powertrain_options-price-with-disclaimer">
                  {(msrp || message) && (
                    <PriceWithDisclaimer
                      value={msrp}
                      message={message}
                      disclaimer={disclaimer}
                      useModal
                    />
                  )}
                </div>
              </div>
              <div className="powertrain__img-container">
                {engineLargeImageUrl && (
                  <img
                    className="powertrain__img"
                    src={engineLargeImageUrl}
                    alt="engine"
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PowertrainOptions;
